{
    "PageTitle_auth": "Autenticação",
    "NAME": "Router",
    "PageTitle_presence": "Presença",
    "PageTitle_changePassword": "Alterar a palavra-passe",
    "PageTitle_forgotPassword": "Esqueceu sua palavra-passe",
    "PageTitle_changeLanguage": "Alterar idioma",
    "PageTitle_resetPassword": "Redefinir palavra-passe",
    "PageTitle_termsAndConditions": "Termos e Condições",
    "PageTitle_cookiePolicy": "Política de Cookies",
    "PageTitle_privacyPolicy": "política de Privacidade",
    "PageTitle_mfa": "Segundo fator de autenticação",
    "PageTitle_teamsAuth": "Autenticação de equipas",
    "PageTitle_insights": "Percepções",
    "PageTitle_crmIntegration": "Integração de CRM",
    "PageTitle_changeUserAgent": "Alterar agente do utilizador",
    "PageTitle_clientConfiguration": "Configuração do cliente",
    "PageTitle_CRMConfiguration": "Configuração de CRM",
    "PageTitle_adminControl": "Controlos de administração",
    "PageTitle_admin": "Administração",
    "PageTitle_cme": "CMEs",
    "PageTitle_status": "Status do servidor de aplicativos",
    "PageTitle_licences": "Licenças",
    "PageTitle_licenceManagement": "Gestão de Licenças",
    "PageTitle_telsys": "Servidores de telefonia",
    "PageTitle_users": "Usuários do aplicativo",
    "PageTitle_partitions": "Partições",
    "PageTitle_device": "Dispositivos",
    "PageTitle_agent": "Agentes",
    "PageTitle_code": "Códigos",
    "PageTitle_auditTrail": "Registro de auditoria",
    "PageTitle_logManagement": "Gerenciamento de logs",
    "PageTitle_loggingSettings": "Configurações de registro",
    "PageTitle_telModuleStatus": "Status do módulo telefônico",
    "PageTitle_recording": "Gravação",
    "PageTitle_messages": "Mensagens",
    "PageTitle_database": "Banco de dados",
    "PageTitle_directory": "Diretório",
    "PageTitle_cxScore": "Pontuação CX",
    "PageTitle_cxScore-cx-score": "Pontuação CX",
    "PageTitle_cxScore-overview": "Pontuação CX",
    "PageTitle_cxScore-calls": "Pontuação CX",
    "PageTitle_cxiDashboard": "Painel de controle CXI"
}